import React, { useState, useRef, useEffect, ReactElement } from 'react';

export const AudioPlayer: React.FC = (): ReactElement => {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const [isMuted, setIsMuted] = useState<boolean>(true);

  useEffect(() => {
    if (audioRef.current) {
      // Browsers often allow autoplay ONLY if muted initially
      audioRef.current.muted = true;
      audioRef.current.play().catch((err: Error) => {
        console.warn("Autoplay blocked by browser policy:", err.message);
      });
    }
  }, []);

  const toggleMute = (): void => {
    if (audioRef.current) {
      const newMuteState = !isMuted;
      audioRef.current.muted = newMuteState;
      audioRef.current.volume = 0.15;


      // If we are unmuting, ensure the track is actually playing
      if (!newMuteState) {
        audioRef.current.play();
      }

      setIsMuted(newMuteState);
    }
  };

  return (
    <div style={styles.container}>
      <audio
        ref={audioRef}
        src="https://storage.googleapis.com/nemvagyunkfronton/haboru.m4a"
        loop
      />

      <button
        onClick={toggleMute}
        style={styles.button}
        aria-label={isMuted ? "Unmute audio" : "Mute audio"}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, width: 200}}>
          <div style={{ width: '20%' }}>
            {isMuted ?
              <img src='https://storage.googleapis.com/nemvagyunkfronton/orbon.png' style={{width: 45}}></img> :
              <img src='https://storage.googleapis.com/nemvagyunkfronton/orboff.png' style={{ width: 45 }}></img>
            }
          </div>
          <div style={{ height: '100%', width: '75%' }}>
            {isMuted ?
              <span style={{
                fontSize: '0.65rem',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                color: '#9ca3af',
                fontWeight: 600,
                marginTop: '4px'
              }}>
                A teljest élményért kattints!
              </span> :
              <span style={{
                fontSize: '0.65rem',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                color: '#9ca3af',
                fontWeight: 600,
                marginTop: '4px'
              }}>
                Köszönöm, elég volt.
              </span>
            }


          </div>
        </div>
      </button>
    </div>
  );
};

// Simple object-based styling for the demo
const styles: { [key: string]: React.CSSProperties } = {
  container: {
    padding: '40px',
    textAlign: 'center',
    fontFamily: 'system-ui, sans-serif'
  },
  button: {
    padding: '12px 24px',
    fontSize: '1rem',
    cursor: 'pointer',
    borderRadius: '16px',
    border: '1px solid #f3f4f6',
    backgroundColor: '#ffffff',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    transition: 'background 0.2s'
  },
  hint: {
    fontSize: '0.8rem',
    color: '#888',
    marginTop: '15px'
  }
};
